export default __webpack_public_path__ + "static/media/pig.243d41aa.svg";